import axios from './_nestAxios'

export const getCentroCosto = _id => axios.get(`/centros-costo/${_id}`)

export const descargarReporteCruceClase6 = data =>
  axios.get('/centros-costo/descargar-reporte-cruce-clase6-vs-centros', { params: data, responseType: 'blob' })

export const getSelect = idNodoPadre =>
  axios.get('/centros-costo', {
    params: {
      tipoConsulta: 'select',
      idNodoPadre: idNodoPadre
    }
  })

export const getAsTreeView = () => axios.get('/centros-costo', { params: { tipoConsulta: 'tree-view' } })

export const actualizarCentroCosto = (_id, data) => axios.put(`/centros-costo/${_id}`, data)

export const actualizarEstado = (_id, data) => axios.put(`/centros-costo/${_id}/cambiar-estado`, data)

export const nuevoCentroCosto = data => axios.post('/centros-costo', data)

export const eliminarCentroCosto = _id => axios.delete(`/centros-costo/${_id}`)

export const obtenertNivelesYCentrosNivelUno = () => axios.get('/centros-costo/niveles-y-centros-nivel-uno')

export const obtenertTodosxNivel = nivel =>
  axios.get('/centros-costo', {
    params: {
      tipoConsulta: 'nivel',
      nivel: nivel
    }
  })

export const obtenerNivel2xIdNodoPadreAsSelect2 = ({ idNodoPadre, busqueda }) =>
  axios.get(`/centros-costo/${idNodoPadre}/nodos-hijos`, {
    params: {
      tipoConsulta: 'select2',
      busqueda
    }
  })

export const obtenerNivel2xIdNodoPadrexTipoAsSelect = ({ idNodoPadre, tipo }) =>
  axios.get(`/centros-costo/${idNodoPadre}/nodos-hijos`, {
    params: {
      tipoConsulta: 'select',
      tipo
    }
  })

export const obtenerxIsAsSoloCodigo = _id =>
  axios.get(`/centros-costo/${_id}`, {
    params: {
      tipoConsulta: 'solo-codigo'
    }
  })
